module.exports = __webpack_public_path__ + "media/img/courses-logo-5504b4fa0fcd2b23e48f56b24f4701d4.svg";